import api from "../storeApi";
import { createAsyncActionWithMeta } from "../../../../../libraries/packages/redux-utils/src/request/action";

export const placeBookingDataGetBookingDataAction = createAsyncActionWithMeta(
  "placeBookingData_placeBookingDataGetBookingDataAction_REQUEST",
  "placeBookingData_placeBookingDataGetBookingDataAction_SUCCESS",
  "placeBookingData_placeBookingDataGetBookingDataAction_FAILURE"
)<Parameters<typeof api.mapSearchPlaces.methods.getBookingData>, any, Error>();
